import React, { useState, useEffect } from 'react';
import './Sidebar.css';

const Sidebar = ({ menuItems, userRole, isOpen, onClose }) => {
  const [userPhoto, setUserPhoto] = useState(null);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    loadUserData();
    
    // Listen for custom event when profile is updated
    const handleProfileUpdate = () => {
      loadUserData();
    };
    
    window.addEventListener('profileUpdated', handleProfileUpdate);
    
    return () => {
      window.removeEventListener('profileUpdated', handleProfileUpdate);
    };
  }, []);

  const loadUserData = () => {
    try {
      const userId = localStorage.getItem('userId');
      const userDataStr = localStorage.getItem('userData');
      const registeredUsers = JSON.parse(localStorage.getItem('registeredUsers') || '[]');
      
      let userData = null;
      
      if (userDataStr) {
        userData = JSON.parse(userDataStr);
      } else if (userId) {
        userData = registeredUsers.find(user => user.id === userId);
      }

      if (userData) {
        setUserName(userData.name || '');
        if (userData.photo) {
          setUserPhoto(userData.photo);
        }
      }
    } catch (error) {
      console.error('Error loading user data:', error);
    }
  };
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userId');
    localStorage.removeItem('userData');
    localStorage.removeItem('token');

    // After logout, send user back to the main marketing site (same behaviour as before)
    const mainAppUrl = process.env.REACT_APP_MAIN_APP_URL || 'http://localhost:3000';
    window.location.href = mainAppUrl;
  };

  const handleNavClick = (onClick) => {
    if (onClick) {
      onClick();
    }
    // Close sidebar on mobile after navigation
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-logo">
        <div className="logo-container">
          <img src="/images/logo-Photoroom.png" alt="Cleaning Service Logo" className="sidebar-logo-img" />
        </div>
        <div className="user-photo-container">
          {userPhoto ? (
            <img src={userPhoto} alt="Profile" className="user-photo" />
          ) : (
            <div className="user-photo-placeholder">
              <span className="photo-icon">📷</span>
            </div>
          )}
          {userName && <span className="user-name">{userName}</span>}
        </div>
        <div className="logo-divider"></div>
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map((item, index) => {
          return (
            <div key={index} className="nav-item-wrapper">
              {item.subItems ? (
                <div className={`nav-item ${item.active ? 'active' : ''}`}>
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-text">{item.label}</span>
                  <span className="nav-arrow">›</span>
                </div>
              ) : (
                <div 
                  className={`nav-item ${item.active ? 'active' : ''}`}
                  onClick={() => handleNavClick(item.onClick)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-text">{item.label}</span>
                  {item.badge > 0 && (
                    <span className="nav-badge">{item.badge > 99 ? '99+' : item.badge}</span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <span className="nav-icon">🚪</span>
          <span className="nav-text">Logout</span>
        </button>
      </div>
      </div>
    </>
  );
};

export default Sidebar;

